import React from 'react';
import { ActionType, Integration } from '../services/api/types';
import { P2GButton } from '@parcel2go/peacock-legacy-core/dist/button';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import IntegrationSpecificText from './IntegrationSpecificText';
import AccountList from './AccountList';

interface props {
  integration: Integration;
  mainActionType: ActionType;
  addAccount: () => void;
  allowAdd: boolean;
  accountLimit: number;
  accountCount: number;
  isSingleAccountMode: boolean;
  close: () => void;
  editAccount: (accountId: string, action: ActionType) => void;
}

export default function IntegrationAccountsAndActions(props: props) {
  return (
    <P2GGrid container spacing={3} direction="column">
      {props.isSingleAccountMode && (
        <P2GGrid item>
          <P2GText>
            <strong>Your account is:</strong>
          </P2GText>
        </P2GGrid>
      )}
      <P2GGrid item>
        <AccountList integration={props.integration} onClose={props.close} editAccount={props.editAccount} />
      </P2GGrid>
      {props.isSingleAccountMode && <IntegrationSpecificText integration={props.integration} />}
      <P2GGrid item>
        {props.allowAdd ? (
          <P2GButton colour="secondary" onClick={props.addAccount}>
            {props.accountCount > 0 ? <>{props.mainActionType} Another Account</> : <>{props.mainActionType} Account</>}
          </P2GButton>
        ) : (
          <P2GButton colour="secondary" onClick={props.close}>
            Close
          </P2GButton>
        )}
      </P2GGrid>
    </P2GGrid>
  );
}
